import request from '@/http/request'
import {
    aiGetLastConversation,
    aiSubmitQuestion,
} from '@/http/api'

export const aiGetLastConversationFn = (data) => {
    return request({
        url: aiGetLastConversation,
        data
    })
}

export const aiSubmitQuestionFn = (data) => {
    return request({
        url: aiSubmitQuestion,
        data
    })
}